import {Injectable} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import {BehaviorSubject} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';

@Injectable({
    providedIn: 'root'
})
export class LocaleService {
    private currentLocaleSubject = new BehaviorSubject<string>('fr');
    public currentLocale$ = this.currentLocaleSubject.asObservable();

    private localeMapping: { [key: string]: any } = {
        'fr': localeFr,
        'en': localeEn
    };

    constructor(private translateService: TranslateService) {
        registerLocaleData(localeFr, 'fr');
        registerLocaleData(localeEn, 'en');

        // S'abonner aux changements de langue de TranslateService
        this.translateService.onLangChange.subscribe(event => {
            this.setLocale(event.lang);
        });

        // Initialiser avec la langue courante
        this.setLocale(this.translateService.currentLang || 'fr');
    }

    setLocale(lang: string): void {
        this.currentLocaleSubject.next(lang);
    }

    getLocale(): string {
        return this.currentLocaleSubject.value;
    }
}
